import { useState } from 'react';
import { CATEGORIES } from '@nudge/shared';
import { FAVORITES_CATEGORY } from '../../utils/groupTemplatesByCategory';

interface Props {
  categoryKey: string;
  count: number;
  defaultOpen?: boolean;
  children: React.ReactNode;
}

const SYNTHETIC_LABELS: Record<string, { label: string; emoji: string }> = {
  [FAVORITES_CATEGORY]: { label: 'Favourites', emoji: '⭐' },
};

export function CategoryAccordion({ categoryKey, count, defaultOpen = true, children }: Props) {
  const [open, setOpen] = useState(defaultOpen);
  const synthetic = SYNTHETIC_LABELS[categoryKey];
  const cat = CATEGORIES[categoryKey];
  const label = synthetic?.label ?? cat?.label ?? categoryKey;
  const emoji = synthetic?.emoji ?? cat?.emoji ?? '•';

  return (
    <section className="mb-4">
      <button
        onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between px-1 py-2 text-left"
      >
        <div className="flex items-center gap-2 text-sm font-medium text-text-primary">
          <span aria-hidden>{emoji}</span>
          <span>{label}</span>
          <span className="text-xs text-text-muted">{count}</span>
        </div>
        <span className="text-text-muted text-sm" aria-hidden>{open ? '▾' : '▸'}</span>
      </button>
      {open && <div className="mt-2">{children}</div>}
    </section>
  );
}
